<template>
  <main class="main page-inside">
    <div class="profile">
      <div class="section profile-section">
        <div class="wrapper">
          <div class="title big title-main">{{ $t(`My profile`) }}</div>
          <div class="profile-content">
            <div class="profile-info">
              <div class="avatar">
                avatar
                <img :src="$parent.profileData.avatar" class="img" />
              </div>
              <div class="text">
                <div class="row">
                  <div class="title small">{{ $t(`Name:`) }}</div>
                  <div class="desc">{{ $parent.profileData.name }}</div>
                </div>
                <div class="row">
                  <div class="title small">{{ $t(`Steame ID:`) }}</div>
                  <div class="desc">{{ $parent.profileData.steam_id }}</div>
                </div>
              </div>
              <div class="balance-block">
                <div class="balance-block-wrapper">
                  <div class="title small">{{ $t(`BALANCE:`) }}</div>
                  <div class="title amount">
                    {{ $parent.profileData.balance }}
                    <img
                      src="../images/coin.svg"
                      class="currency-icon"
                      alt="coin"
                    />
                  </div>
                  <div class="button" @click="$parent.openTopUpModal">
                    {{ $t(`Top up balance`) }}
                  </div>
                </div>
              </div>
              <ProfilePayoutBalanceBlock
                v-if="$parent.settings.payout_enabled"
                :payout-balance="$parent.profileData.payout_balance"
                @withdraw="$parent.openWithdrawModal"
              />
              <button class="button black logout-btn" @click="$parent.logout">
                <span>{{ $t(`LOG OUT`) }}</span>
                <img
                  src="../assets/log-out.svg"
                  class="logout-icon"
                  alt="Logout"
                />
              </button>
            </div>
            <div class="tables">
              <div class="history-info">
                <div
                  class="title medium"
                  v-if="$parent.orderHistory && $parent.orderHistory.length"
                >
                  {{ $t(`Purchase history`) }}
                </div>
                <div
                  class="status-filters"
                  v-if="$parent.orderHistory && $parent.orderHistory.length"
                >
                  <button
                    v-for="option in $parent.statusOptions"
                    :key="option.id"
                    class="status-filter-btn"
                    :class="{ active: $parent.statusFilter === option.id }"
                    :style="{
                      backgroundColor: option.color,
                      color: option.id === 'pending' ? '#333' : '#fff',
                    }"
                    @click="$parent.setStatusFilter(option.id)"
                  >
                    {{ option.text }}
                  </button>
                </div>
                <div
                  class="table-container"
                  v-if="$parent.orderHistory && $parent.orderHistory.length"
                >
                  <table>
                    <thead>
                      <tr>
                        <td>{{ $t(`Date`) }}</td>
                        <td>{{ $t(`Item`) }}</td>
                        <td>{{ $t(`Count`) }}</td>
                        <td>{{ $t(`Total price`) }}</td>
                        <td>{{ $t(`Status`) }}</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, i) in paginatedPurchaseHistory"
                        :key="i"
                      >
                        <td>{{ $parent.formatDate(item.date) }}</td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.count }}</td>
                        <td>
                          <b>{{ item.total_price }} {{ item.currency }}</b>
                        </td>
                        <td>{{ item.status }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- Пагинация для Purchase history -->
                <div
                  v-if="
                    $parent.orderHistory &&
                    $parent.orderHistory.length &&
                    totalPurchasePages > 1
                  "
                  class="table-pagination"
                >
                  <div
                    class="pagination-item prev"
                    :class="{ disabled: currentPurchasePage === 1 }"
                    @click="changePurchasePage(currentPurchasePage - 1)"
                  >
                    «
                  </div>
                  <div
                    v-for="page in getVisiblePages(
                      totalPurchasePages,
                      currentPurchasePage,
                    )"
                    :key="page"
                    class="pagination-item"
                    :class="{ active: page === currentPurchasePage }"
                    @click="changePurchasePage(page)"
                  >
                    {{ page }}
                  </div>
                  <div
                    class="pagination-item next"
                    :class="{
                      disabled: currentPurchasePage === totalPurchasePages,
                    }"
                    @click="changePurchasePage(currentPurchasePage + 1)"
                  >
                    »
                  </div>
                </div>
                <div
                  class="title medium"
                  v-if="$parent.depositHistory && $parent.depositHistory.length"
                >
                  {{ $t(`Payment history`) }}
                </div>
                <div
                  class="table-container"
                  v-if="$parent.depositHistory && $parent.depositHistory.length"
                >
                  <table>
                    <thead>
                      <tr>
                        <td>{{ $t(`Date`) }}</td>
                        <td>{{ $t(`Amount`) }}</td>
                        <td>{{ $t(`Status`) }}</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in paginatedPaymentHistory" :key="i">
                        <td>{{ $parent.formatDate(item.date) }}</td>
                        <td>{{ item.amount }} {{ item.currency }}</td>
                        <td>{{ item.status }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- Пагинация для Payment history -->
                <div
                  v-if="
                    $parent.depositHistory &&
                    $parent.depositHistory.length &&
                    totalPaymentPages > 1
                  "
                  class="table-pagination"
                >
                  <div
                    class="pagination-item prev"
                    :class="{ disabled: currentPaymentPage === 1 }"
                    @click="changePaymentPage(currentPaymentPage - 1)"
                  >
                    «
                  </div>
                  <div
                    v-for="page in getVisiblePages(
                      totalPaymentPages,
                      currentPaymentPage,
                    )"
                    :key="page"
                    class="pagination-item"
                    :class="{ active: page === currentPaymentPage }"
                    @click="changePaymentPage(page)"
                  >
                    {{ page }}
                  </div>
                  <div
                    class="pagination-item next"
                    :class="{
                      disabled: currentPaymentPage === totalPaymentPages,
                    }"
                    @click="changePaymentPage(currentPaymentPage + 1)"
                  >
                    »
                  </div>
                </div>
                <div class="title medium">Sell requests</div>
                <ProfileSellRequestsTab
                  :sell-request-history="$parent.sellRequestHistory"
                  :sell-request-meta="$parent.sellRequestMeta"
                  :format-date="formatSellDate"
                  :settings="$parent.settings"
                  @coming-soon="$parent.openComingSoonModal"
                  @sell-items="$parent.openSellItemsModal"
                  @view-offer="$parent.openCounterOfferModal"
                  @change-page="$parent.getSellRequestHistory"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import ProfilePayoutBalanceBlock from '../components/profile/ProfilePayoutBalanceBlock.vue'
import ProfileSellRequestsTab from '../components/profile/ProfileSellRequestsTab.vue'

export default {
  name: 'Profile',
  props: [],
  components: {
    ProfilePayoutBalanceBlock,
    ProfileSellRequestsTab,
  },
  data: function () {
    return {
      currentPurchasePage: 1,
      currentPaymentPage: 1,
      itemsPerPage: 3,
    }
  },
  computed: {
    paginatedPurchaseHistory() {
      if (!this.$parent.orderHistory) return []
      const start = (this.currentPurchasePage - 1) * this.itemsPerPage
      const end = start + this.itemsPerPage
      return this.$parent.orderHistory.slice(start, end)
    },
    paginatedPaymentHistory() {
      if (!this.$parent.depositHistory) return []
      const start = (this.currentPaymentPage - 1) * this.itemsPerPage
      const end = start + this.itemsPerPage
      return this.$parent.depositHistory.slice(start, end)
    },
    totalPurchasePages() {
      if (!this.$parent.orderHistory) return 0
      return Math.ceil(this.$parent.orderHistory.length / this.itemsPerPage)
    },
    totalPaymentPages() {
      if (!this.$parent.depositHistory) return 0
      return Math.ceil(this.$parent.depositHistory.length / this.itemsPerPage)
    },
  },
  mounted() {},
  methods: {
    changePurchasePage(page) {
      if (page >= 1 && page <= this.totalPurchasePages) {
        this.currentPurchasePage = page
      }
    },
    changePaymentPage(page) {
      if (page >= 1 && page <= this.totalPaymentPages) {
        this.currentPaymentPage = page
      }
    },
    getVisiblePages(totalPages, currentPage) {
      if (totalPages <= 3) {
        return Array.from({ length: totalPages }, (_, i) => i + 1)
      }

      if (currentPage <= 2) {
        return [1, 2, 3]
      } else if (currentPage >= totalPages - 1) {
        return [totalPages - 2, totalPages - 1, totalPages]
      } else {
        return [currentPage - 1, currentPage, currentPage + 1]
      }
    },
    formatSellDate(date) {
      if (typeof date === 'number') {
        return this.$parent.formatDate(date)
      }
      return date
    },
  },
}
</script>
